<template>
    <div class="word-wrap">
        <div class="word-title">
            {{ title }}
        </div>
        <template v-for="(item,index) in arrWork">
            <div class="content-box">
                <div class="content-title">
                    <div :class="['name',{'name-after':mode == 0}]">
                        {{ item.title }}
                    </div>
                    <div class="info">
                        <template v-if="mode == 1">已全部验收合格：{{ item.quality_point }}项</template>
                        <template v-else>完工时间：{{ item.time || '--' }}</template>
                    </div>
                    <div :class="['unfold-icon',{'unfold':item.isUnfold}]" @click="toUnfold(index)"></div>
                </div>
                <div :class="['content',{'content2':mode == 1}]">
                    {{ item.tips || item.desc }}
                </div>
                <template v-if="item.isUnfold && mode == 0">
                    <div class="img-box">
                        <template v-for="(img,img_i) in item.imgs">
                            <img :src="img.image_url" alt=""
                                 @click="openPreview(item.imgs,img_i)"/>
                        </template>
                    </div>
                </template>
                <template v-if="item.isUnfold && mode == 1">
                    <div class="tags-box">
                        <template v-for="(tag,tag_i) in item.tag_list">
                            <div :class="['tag-item',{'tag-act':item.nTagIndex == tag_i}]" @click="toTag(tag_i,index)">
                                {{ tag.tag_name }}
                            </div>
                        </template>
                    </div>
                </template>
                <template v-if="item.isUnfold && mode == 1">
                    <div class="img-swipe">
                        <!-- :autoplay="3000" -->
                        <van-swipe :ref="`swipe_${index}`" class="swipe-box" indicator-color="#275BA6"
                                   @change="onSwipe($event,index)">
                            <template v-for="(img,img_i) in item.imgs">
                                <van-swipe-item @click="openPreview(item.imgs,img_i)">
                                    <div class="swipe-item">
                                        <p>{{ item.photo_text }}</p>
                                        <img :src="img" alt=""/>
                                    </div>
                                </van-swipe-item>
                            </template>
                        </van-swipe>
                        <div class="swipe-dit">
                            <template v-for="(img,img_i) in  item.imgs">
                                <img :class="['img',{'img-act':item.nImgs == img_i}]" :src="img" alt=""
                                     @click="toSwipeDit(`swipe_${index}`,img_i,index)"/>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <media-preview :show="isShowPreview" :nIndex="nPreviewIndex" :arrUrl="arrPreview"
                       @close="closePreview"></media-preview>
        <img src="@/assets/images/antV2/back-icon02.png" v-if="mode == '0'" class="back-icon" @click="toBack" alt="">
    </div>
</template>

<script>
import mediaPreview from "@/page/project/v3/components/preview";
import {getWordPrevirew} from "@/js/project/v3/index.js";

export default {
    name: "wordPreview",
    components: {
        mediaPreview
    },
    data() {
        return {
            mode: 0, //0 -项目详情，1 - 有交付书
            title: '',
            isShowPreview: false,
            nPreviewIndex: 0,
            arrPreview: [],
            arrWork: [],
        }
    },
    created() {
        // this.mode = this.$route.query.mode || 0;
        this.mode = 0;
        if(this.mode == 1){
            this.getWordInfoFun();
        }else{
            this.getWordInfoFun2();
        }
    },
    methods: {
        getWordInfoFun() {
            this.$store.commit("loadSwitch", true);
            getWordInfo({
                rule_report_id: this.$route.query.id,
                projectmgnid: this.$route.query.projectId
            }).then((res) => {
                let data = res.data.data.result;
                this.title = data.title.replaceAll('监理报告', '');
                if (data.process && data.process.length > 0) {
                    this.arrWork = data.process.map((it) => {
                        let imgs = [];
                        if (it.tag_list && it.photo_list && it.tag_list.length > 0) {
                            imgs = it.photo_list[it.tag_list[0].tag_id];
                        }

                        let obj = {
                            ...it,
                            isUnfold: true,
                            nTagIndex: 0,
                            nImgs: 0,
                            imgs: imgs
                        }

                        return obj;
                    });

                }
                this.$store.commit("loadSwitch", false);
            })
        },
        getWordInfoFun2() {
            this.$store.commit("loadSwitch", true);
            getWordPrevirew({
                cate_id: this.$route.query.id,
                project_id: this.$route.query.projectId
            }).then((res) => {
                let data = res.data.data.result[0];
                this.title = data.title;
                if (data.children && data.children.length > 0) {
                    this.arrWork = [];
                    data.children.forEach((it) => {
                        if(it.images && it.images.length > 0){
                            let time = new Date(it.actual_finish_date)
                            let obj = {
                                ...it,
                                time: it.actual_finish_date ? it.actual_finish_date.split(' ')[0].replaceAll('-', '.') : '',
                                isUnfold: true,
                                imgs: it.images
                            }
                            this.arrWork.push(obj)
                        }
                    });

                }
                console.log(data,'data')
                this.$store.commit("loadSwitch", false);
            })
        },
        toUnfold(i) {
            this.arrWork[i].isUnfold = !this.arrWork[i].isUnfold;
        },
        toTag(tag_i, i) {
            this.arrWork[i].nTagIndex = tag_i;
            this.arrWork[i].nImgs = 0;
            this.arrWork[i].imgs = this.arrWork[i].photo_list[this.arrWork[i].tag_list[tag_i].tag_id];
        },
        onSwipe(img_i, i) {
            this.arrWork[i].nImgs = img_i;
        },
        toSwipeDit(ref, img_i, i) {
            this.$refs[ref][0].swipeTo(img_i);
            this.openPreview(this.arrWork[i].imgs, img_i);
        },
        openPreview(arr, i) {
            this.arrPreview = arr.map((it) => {
                return {
                    pic: it.image_url || it,
                    type: 'image'
                }
            });
            this.nPreviewIndex = i;
            this.isShowPreview = true;
        },
        closePreview() {
            this.isShowPreview = false;
        },
        toBack(){
            this.$router.back()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
